import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

   hasError = false;
  errorMessage = '';

  public setError = (message: string) => {
    if (!message || message === '') {
      this.clear();
    }
    else {
      this.errorMessage = message;
      this.hasError = true;
    }
  }

  public clear = () => {
    this.errorMessage = '';
    this.hasError = false;
  }
}
